import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";

const ProcessAppointmentPopup = ({ isOpen, onRequestClose, payment }) => {
  const [newDate, setNewDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [appointmentExists, setAppointmentExists] = useState(false);
  const [pkg, setPackage] = useState(null);
  const [lab, setLab] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const navigate = useNavigate();
  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);

  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const token = JSON.parse(localStorage.getItem("data")).token;
  useEffect(() => {
    if (payment) {
      (async () => {
        setNewDate(payment?.appointmentDate);
        setLoading(true);
        try {  
            // Fetch lab details
            const labRes = await axios.get(
                `/api/labdetails/${payment.labId}`, 
                { headers: { Authorization: `Bearer ${token}` } }
              );
              setLab(labRes.data);
          // Fetch package details
          const pkgRes = await axios.get(
            `/api/package/${payment.packageId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setPackage(pkgRes.data);
  
          // Check if appointment exists
          const res = await axios.post(
            `/api/payment/checkAppointmentExist`,
            { paymentId: payment.paymentId },
            { headers: { Authorization: `Bearer ${token}` } }
          );
  
          setAppointmentExists(res.data === true);
        } catch (error) {
          handleError(error);
          setAppointmentExists(false); // assume false on error
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [payment]);
  
  const handleDateChange = (e) => {
    setNewDate(e.target.value);
    
  };

   const openTestsModal = (pkgid) => {
    setSelectedPackage(pkgid);
        setIsTestsModalOpen(true);
    };
    const closeTestsModal = () => {
        setSelectedPackage(null);
      setIsTestsModalOpen(false);
     
    };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newDate) {
      toast.warn("Please select appointment date");
      return;
    }

    const selectedDate = new Date(newDate);


    if (selectedDate.getDay() === 0) {
      toast.warn("Please select a weekday other than Sunday.");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        "/api/employeeappointment/process-appointment",
        {
          appointmentDate: newDate,
          packageId: payment.packageId,
          labId: payment.labId,
          userid:payment.userid,
          orderId:payment.orderId
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Lab Appointment Processed successfully.");
      onRequestClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Process Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading">Loading...</div>}

        {appointmentExists===true ? (
          <div className="text-success fs-5 fw-bold text-center">
            Payment already validated.
          </div>
        ) : (
          <div className="col-xl-10 mx-xl-auto">
            <div className="card card-raised mb-3">
              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                     <p>Lab: {lab?.labname}({lab?.labcode})</p>
                                          <p>Package: {pkg?.packagename}
                                          {pkg!==null && (
                                        <span style={{ marginLeft: "40px" }}>
                                          <FiInfo 
                                           onClick={() => openTestsModal(pkg?.id)}
                                           style={{
                                             cursor: 'pointer'
                                           }}
                                          />
                                        </span>
                                      )}
                                          </p>
                  <div className="row">
                    <div className="form-floating-sm mb-2">
                      <label htmlFor="newDate" className="me-1">Appointment Date:</label>
                      <input
                        className="form-control"
                        id="newDate"
                        type={userRole !== 'ROLE_EMPLOYEE' ? "date" : "text"}
                        placeholder="Select new date"
                        value={newDate}
                        onChange={userRole !== 'ROLE_EMPLOYEE' ? handleDateChange : undefined}
                        min={new Date().toISOString().split("T")[0]}
                        required
                      />
                    </div>
                    {/* You can insert lab dropdowns here if needed */}
                  </div>
                  <br />
                  <Button variant="secondary" onClick={onRequestClose}>
                    Close
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <input
                    type="submit"
                    value="Save"
                    className="btn btn-primary"
                    disabled={loading}
                  />
                  
                 
                </form>
              </div>
            </div>
            {isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProcessAppointmentPopup;
